import React from 'react';
import { IconType, IconBaseProps } from 'react-icons';

interface IconProps extends Omit<IconBaseProps, 'icon'> {
  icon: IconType;
}

export const Icon: React.FC<IconProps> = ({ icon: IconComponent, ...props }) => {
  // Type assertion to ensure IconComponent is treated as a valid JSX component
  const Icon = IconComponent as React.ComponentType<IconBaseProps>;
  
  return (
    <span className="icon" style={{ 
      fontSize: '20px',
      opacity: 0.9,
      verticalAlign: 'middle',
      display: 'inline-flex'
    }}>
      <Icon {...props} />
    </span>
  );
};